import { useConcatenateFilterSelection } from '../../../../components/filters/hooks/common.hook';
import { FILTER_NAMES } from '../../../../components/filters/hooks/filter-names.constants';
import {
  useFilterCompactViewSelection,
  useFilterMemoSelection,
} from '../../../../components/filters/hooks/report-filter-selection.hook';
import { useEncodeFilters } from '../../../../components/filters/hooks/use-encode-filters.hook';
import { useFilterComparisonPeriodsSelection } from '../../../../components/filters/hooks/use-filter-comparison-periods-selection.hook';
import { useFilterDrilltroughSelection } from '../../../../components/filters/hooks/use-filter-drillthrough-selection.hook';
import { useFilterPanelSelection } from '../../../../components/filters/hooks/use-filter-panel-selection.hook';
import { FilterEncoderComponentProps } from '../../../../components/filters/interfaces/filterable-component-props.interface';

/**
 * This component is responsible for gathering filter selections and then update the URL with them.
 */
export const DecompInsightsFilterProvider = ({
  children,
}: FilterEncoderComponentProps) => {
  const filterSelection = useConcatenateFilterSelection(
    useFilterCompactViewSelection(), // Table selections
    useFilterPanelSelection(), // Global filters
    useFilterDrilltroughSelection(), // Drill through/Decomp model filters
    useFilterComparisonPeriodsSelection(), // Prev and Post period filters.
    useFilterMemoSelection(FILTER_NAMES.PERIODLENGTH),
  );
  // Updates URL with encoded filters.
  useEncodeFilters(filterSelection, true);

  return <>{children}</>;
};
